import { render, staticRenderFns } from "./PatientContactTasks.vue?vue&type=template&id=1a81567d&"
import script from "./PatientContactTasks.vue?vue&type=script&lang=js&"
export * from "./PatientContactTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports